export default "__VITE_ASSET__D4pyR8sH__"